var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-5",attrs:{"loading":_vm.getLoading,"headers":_vm.headers,"items":_vm.getBuyer},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.user_buyer_id)+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('button-remove-buyer',{attrs:{"buyerProp":item}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }